import { toGqlId } from "@src/api/formatters/shopify";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/component/selectors/getVariationDraft";
import type { OnsiteUpsellComponent } from "@src/store/slices/experienceBuilder/types";
import {
  openProductPicker,
  setProductPickerProducts,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import {
  ProductPickerProduct,
  ProductPickerSelectedProduct,
} from "@src/store/slices/productPicker/types";

// THEN "specific products": open the variant picker seeded from the rule's
// stored items — hydrate the grid too so variant selection reconciles pre-load.
export const openOnsiteUpsellActionProductPicker = createAsyncThunk<
  void,
  number
>(
  "productPicker/openOnsiteUpsellActionProductPicker",
  (ruleIndex, { dispatch, getState }) => {
    dispatch(openProductPicker({ type: "onsiteUpsellAction", ruleIndex }));

    const draft = getVariationDraft(getState()) as
      | OnsiteUpsellComponent
      | undefined;
    const selection = draft?.rules[ruleIndex]?.products;
    const items = selection?.source === "products" ? selection.products : [];

    const products: ProductPickerProduct[] = items.map((item) => ({
      id: item.productId,
      title: item.productTitle,
      image: item.productImage ?? undefined,
      handle: item.handle ?? "",
      requiresSellingPlan: undefined,
      hasVariantsThatRequiresComponents: false,
      sellingPlanGroupCount: 0,
      options: item.options,
      variants: item.variants.map((v) => ({
        id: toGqlId(v.variantId, "ProductVariant"),
        title: v.variantTitle,
        price: v.price,
        compareAtPrice: v.compareAtPrice ?? null,
        availableForSale: v.availableForSale ?? true,
        image: v.variantImage ?? null,
        selectedOptions: v.variantOptions ?? [],
      })),
    }));
    dispatch(setProductPickerProducts(products));

    const selectedProducts: ProductPickerSelectedProduct[] = items.map(
      (item) => {
        const included = item.variants.filter(
          (v) => v.inclusionType === "include"
        );
        // `undefined` selectedVariantIds means "all variants" to the picker.
        const selectedVariantIds =
          included.length === item.variants.length
            ? undefined
            : included.map((v) => toGqlId(v.variantId, "ProductVariant"));
        return {
          id: item.productId,
          title: item.productTitle,
          image: item.productImage ?? undefined,
          handle: item.handle ?? "",
          requiresSellingPlan: undefined,
          selectedVariantIds,
          totalVariantCount: item.variants.length,
        };
      }
    );
    dispatch(setProductPickerSelectedProducts(selectedProducts));
  }
);
